import React from 'react';
import AdComponent from '../../AdTech/adWrapper';

const MMTAd = props => {
  const {
    id,
    lob,
    pageName,
    section,
    cid,
    callInit = true,
    styles = {},
    searchContextDetails = null
  } = props;

  if (cid) {
    return <AdComponent uuid={cid} searchContext={searchContextDetails} />;
  }

  if (id) {
    return (
      <AdComponent
        uuid={id}
        lob={lob}
        pageName={pageName}
        section={section}
        searchContext={searchContextDetails}
      />
    );
  }

  return null;
};

export default MMTAd;
